import Notification from "../../components/Notification/Notification";

const NotificationPage = () => {
  return <Notification />;
};

export default NotificationPage;
